(function() {

    'use strict';

    angular.module('Filters')
    
    .filter('computeTotal', function() {
        return function(item) {
            
            return (item.value && item.quantity) ? '$'+ (item.value * item.quantity) +' AUD' : 'N/A';

        };
    });

})();


// WEBPACK FOOTER //
// ./js/filters/shipment.js